import React, { ReactNode } from 'react';
import Logo from './Logo';
import Copyrights from './Copyrights';

interface ErrorLayoutProps {
  children: ReactNode;
}

const ErrorLayout: React.FC<ErrorLayoutProps> = ({ children }) => {
  return (
    <div className="app-layout__error">
      <header className="header">
        <Logo />
      </header>
      <main className="main">{children}</main>
      <footer className="footer">
        <Copyrights />
      </footer>
    </div>
  );
};

export default ErrorLayout;
